module.exports = {"TXTWCL_Deposit":{"id":"TXTWCL_Deposit","defaultMessage":"Indbetal","track":"Deposit"}}